import { AddCircle } from "@mui/icons-material";
import { CardHeader, Icon, IconButton, Grid } from "@mui/material";
import { AdviceService } from "app/services/advice-service";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert } from 'app/components/Alert';
import { AlertService } from "app/services/alertService"
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import moment from "moment";
import LoadingModelComponent from "app/components/LoadingModelComponent";
import useAuth from 'app/hooks/useAuth';


const ListAdvice = () => {

    function getClientName(params) {

        return `${params.row.client.clientName} `;
    }
    function getWarehouse(params) {


        return `${params.row.subWarehouse.warehouse.warehouseName} `;
    }
    function getOrderType(params) {


        return `${params.row.orderType.description}`;
    }
    const columns = [
        { field: 'id', headerName: 'Id', width: 130, hide: true },
        { field: 'adviceItemCode', headerName: 'InWard Code', width: 130, flex: 1 },
        { field: 'createdDate', headerName: 'InWard Date', width: 150, valueFormatter: params => moment(params?.value).format("DD/MMM/yyyy hh:mm"), flex: 1 },
        { field: 'clientName', headerName: 'Client Name', width: 130, flex: 1, valueGetter: getClientName },
        { field: 'warehouseName', headerName: 'Warehouse Name', width: 130, flex: 1, valueGetter: getWarehouse },
        { field: 'adviceItemStatus', headerName: 'Inward Status', width: 130, flex: 1 },
        { field: 'description', headerName: 'Order Type', width: 150, valueGetter: getOrderType, flex: 1 },
        {
            field: 'action',
            headerName: 'Action',
            sortable: false,
            renderCell: (params) => {
                return <Grid>
                    <IconButton onClick={() => toEditOrCreate(params.row)}  >
                        <Icon color="action" >edit</Icon>
                    </IconButton>
                    <IconButton onClick={() => deleteById(params.row)}>
                        <Icon color="action" >delete</Icon>
                    </IconButton>
                </Grid>
            },
        },

    ];
    const [page, setPage] = useState(25);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isDataLoad, setisDataLoad] = useState(false);
    const { user } = useAuth();
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const toEditOrCreate = (data) => {
        navigate('/inward/advice/create', { state: { data } });
    }
    const deleteById = (index) => {

        if (index.adviceItemStatus === "check in created") {
            AlertService.error('check in created , we cant delete this inward.', { keepAfterRouteChange: true });
            return;
        }
        setisDataLoad(true);
        AdviceService.delete(index.id)
            .then((res) => { setisDataLoad(false); loadAdviceItem() })
            .catch((err) => { console.log(err.message); setisDataLoad(false) });

    }
    const navigate = useNavigate();
    const [adviceList, setAdviceList] = useState([]);

    useEffect(() => loadAdviceItem(), []
    );
    const loadAdviceItem = () => {
        setisDataLoad(true);
        AdviceService
            .getAll()
            .then(advice => {
                if (advice !== null) {
                    // setAdviceList(advice);
                    setAdviceList(advice.filter(res => res.customerId === user?.clientId));
                }
                setisDataLoad(false);
                console.log("old==>", adviceList)
                // else { AlertService.error("There is no Data for Login User", { keepAfterRouteChange: true }); }
            })
            .catch((err) => {

                console.log(err.message);
                setisDataLoad(false);
                AlertService.error(err.message, { keepAfterRouteChange: true });
            });
    }
    return (
        <div style={{ height: '80%', width: '100%' }}>
            <Alert />
            <LoadingModelComponent isLoading={isDataLoad} />
            <Grid><a href='/assets/images/wms_template/inward/inwardV1_Template.csv' download>Click to download Inward Template</a>
                <CardHeader title="inward Notes" action={
                    <IconButton aria-label="settings" onClick={() => toEditOrCreate()}><AddCircle sx={{ fontSize: 30 }} align="right" /></IconButton>
                } >
                </CardHeader>
            </Grid>
            <DataGrid
                rows={adviceList}
                density="compact"
                columns={columns}

                disableMultipleSelection={true}
                pageSize={page}
                rowsPerPage={rowsPerPage}
                onPageSizeChange={(newPageSize) => setPage(newPageSize)}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[2, 10, 25, 50, 75, 100]}

                pagination
                components={{ Toolbar: GridToolbar }}
            />
        </div>

    );
}

// const StyledTable = styled(Table)(() => ({
//     whiteSpace: "pre",
//     "& thead": {
//         "& tr": { "& th": { paddingLeft: 0, paddingRight: 0 } },
//     },
//     "& tbody": {
//         "& tr": { "& td": { paddingLeft: 0, textTransform: "capitalize" } },
//     },
// }));

export default ListAdvice